import React from 'react'; 
import CusAddBtn from './CusAddBtn';
import CusRemoveBtn from './CusRemoveBtn';

const AddRemoveBtn = (props) => {
    const {defBtnValue, seq, label,disabled } = props;
 
    const onAddBtnClick = (e)=> {
      
        props.onClick('Add')
    }
    const onRemoveBtnClick = (e) => {
        props.onClick('Remove')
    }

    return(
        <div>
            {defBtnValue?<CusAddBtn id={'AddBtn'+seq} label={label} onClick={onAddBtnClick} disabled={disabled} />:
            <CusRemoveBtn id={'RemoveBtn'+seq} label={'REMOVE'} disabled={disabled} onClick={onRemoveBtnClick} />}
        </div> 
    )
}

export default AddRemoveBtn